import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSepaComponent } from './simple-icons-sepa.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSepaComponent ],
    exports:      [ SimpleIconsSepaComponent ],
    bootstrap:    []
})
export class SimpleIconsSepaModule {}
